export default __webpack_public_path__ + "static/aspnet-ba5d76390231cf1c51ff7ffe3056860e.png";